module.exports = __webpack_public_path__ + "static/media/italy.e5f0feaa.svg";